/** @format */
import {format, eachDayOfInterval} from 'date-fns';

import NoteModal from './index';
import {AggregatedContainer, NotesContainer} from './styles';
import {TooltipScatterData} from '../../../models/scatters';

interface Props {
  tooltipData?: TooltipScatterData;
  refetchNotes?: () => void;
}

const AggregatedNoteModal = ({tooltipData, refetchNotes}: Props) => {
  if (!tooltipData) {
    return null;
  }

  const generateAllDaysInRange = () => {
    const startDate = tooltipData.startOn;
    const endDate = tooltipData.endOn;

    if (!startDate) {
      return [endDate];
    }

    const days = eachDayOfInterval({
      start: new Date(startDate),
      end: new Date(endDate),
    });

    return days.map(day => format(day, 'yyyy-MM-dd'));
  };

  const allDays = generateAllDaysInRange();

  return (
    <AggregatedContainer>
      <NotesContainer>
        {allDays.map(date => (
          <NoteModal key={date} date={date} refetchNotes={refetchNotes} isAggregated />
        ))}
      </NotesContainer>
    </AggregatedContainer>
  );
};

export default AggregatedNoteModal;
